import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, Route } from 'react-router-dom';
export function RedirectWithStatus(props) {
    const { from, to, status } = props;
    return (_jsx(Route, { exact: props.exact, render: ({ staticContext }) => {
            if (staticContext) {
                staticContext.statusCode = status;
            }
            return _jsx(Redirect, { from: from, to: to });
        } }));
}
//# sourceMappingURL=index.js.map